import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import '../RetailHome/RetailHome.scss';
import RetailPage from 'src/containers/Page/RetailPage';
import { RootState } from 'src/configs/store';
import AutoTransactionModal from './AutoTransactionModal';
import ConfirmTransferUnderBalance from 'src/components/Modal/TransferUnderBalance/ConfirmTransferUnderBalance';

export default function Home() {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const contentTransactions  = useSelector((state: RootState) => state.content.autoTransactions);
  const autoTransactions  = useSelector((state: RootState) => state.peripherals.autoTransactions);
  const transferUnderBalance = useSelector((state: RootState) => state.peripherals.transferUnderBalance);
  const currentBalance = useSelector((state: RootState) => state.peripherals.closingBalance);

  const [transactionName, setTransactionName] = useState('');
  const [multipleTill, setMultipleTill] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [buttonId, setButtonId]= useState(0);
  const [amount, setAmount] = useState(0);
  const [requireProperties, setRequireProperties] = useState(false);
  const [selectedTill, setSelectedTill] = useState(null);
  const [tillOptions, setTillOptions] = useState([]);
  const [showBalanceModal, setShowBalanceModal] = useState(false);
  const [isDebitTill, setIsDebitTill] = useState(false);
  const [type, setType] = useState('origTill');

  const handleTransaction = async (name: string, id:number) => {
    const func = autoTransactions.find((transaction) => transaction.id === id);
    setTransactionName(name);
    let options = null;
    if (func['function'] === 'FLOAT_OUT'){
      setType('reverseTill');
    }

    if (func['function'] === 'FLOAT_IN'){
      setType('origTill');
    }

    if (func.debitParam === 'TILLID' || func.debitParam === 'AUTOSHOPID'){
      setIsDebitTill(true);
    }

    if (func['creditParam'] === 'MANUALTILLID' || func['debitParam'] === 'MANUALTILLID'){
      setRequireProperties(true);
      options = await dispatch.peripherals.getOrganisationTills();
      const newTills = _.filter(options?.collection, (till) => {
        return +till.id !== +(localStorage.getItem('tillId'));
      });
      setTillOptions(newTills);
      setMultipleTill(true);
    }

    setButtonId(id);
    setShowModal(true);
  };

  const handleSubmission = async () => {
    await dispatch.peripherals.getAutoTransactionPayload({ id: buttonId,
      amount,
      ...(type === 'origTill' && multipleTill && { creditParam: selectedTill }),
      ...(type === 'reverseTill' && multipleTill && { debitParam: selectedTill })
    });
    setShowModal(false);
    setAmount(0);
    setRequireProperties(false);
    setSelectedTill(null);
    setIsDebitTill(false);
    setTillOptions([]);
    setType('origTill');
    setShowBalanceModal(false);
    setMultipleTill(false);
  };

  const handleClose = () => {
    setShowModal(false);
    setAmount(0);
    setRequireProperties(false);
    setSelectedTill(null);
    setIsDebitTill(false);
    setTillOptions([]);
    setType('origTill');
    setMultipleTill(false);
  };

  const handleSelecedAmount = (e) => {
    setAmount(e.target.value);
  };

  const checkTillBalance = async () => {
    if (!transferUnderBalance && isDebitTill){
      const balanceTooLow = currentBalance < +amount ? true : false;

      if (balanceTooLow){
        setShowBalanceModal(true);
      } else {
        handleSubmission();
      }
    } else {
      await handleSubmission();
    }
  };

  return (
    <RetailPage>
      <div className="retail-home">
        {
          _.map(contentTransactions, (menuItem) => {
            return (
              <button
                key={ menuItem.id }
                className="btn--primary retail-home__button"
                type="button"
                disabled={ menuItem.disabled }
                name="cancel-ticket"
                value={ menuItem.id }
                onClick={ () => handleTransaction(menuItem.name, menuItem.id) }
              >
                { `${ t(`autoTransactions.${ menuItem.name }`) }` }
                { menuItem.subtitle && <div>{ t(`autoTransactions.${ menuItem.subtitle }`) }</div> }
              </button>
            );
          })
        }
        {
          showModal && (
            <AutoTransactionModal
              onClose={ handleClose }
              setAmount={ handleSelecedAmount }
              balance={ 0 }
              transactionName= { transactionName }
              setSelectedTill={ setSelectedTill }
              requireProperties={ requireProperties }
              tillOptions={ tillOptions }
              onApprove={ checkTillBalance }
            />)
        }
        {
          showBalanceModal && (
            <ConfirmTransferUnderBalance onClose={ () => setShowBalanceModal(false) } onSubmit={ handleSubmission } value={ amount + '' } />
          )
        }
      </div>
    </RetailPage>
  );
}
